import React from 'react';
/* search text */
export const Search = React.createContext(['Search', () => {}]);
